import React from 'react';
import AboutBusinessApp from './AboutBusinessApp/AboutBusinessApp';
import BusinessAppDownload from './BusinessAppDownload/BusinessAppDownload';
import BusinessFeauters from './BusinessFeauters/BusinessFeauters';
import BusinessHero from './BusinessHero/BusinessHero'
import BusinessNewsletter from './BusinessNewsletter/BusinessNewsletter';
import ExcitingFeatures from './ExcitingFeatures/ExcitingFeatures';
import FeaturedLevels from './FeaturedLevels/FeaturedLevels';
import SuppliersFeedback from './SuppliersFeedback/SuppliersFeedback';
import Page from "../../Page/Page";
import SeoHelmet from '../../../Components/SeoHelmet/SeoHelmet';

const Business = () => {
    return (
        <Page>
            <SeoHelmet title="Business - Elite Partyz App" keywords="Party, Elite Party, Event, Event manager, Business, Business App" description="Revolutionising the Party Industry! The ultimate party app for your business. Increase exposure of your business through our platform and reach customers ..." canonicalLink="/business" />
            <div className="business-page">
                <BusinessHero />
                <ExcitingFeatures />
                <AboutBusinessApp />
                <BusinessFeauters />
                <FeaturedLevels />
                <BusinessAppDownload />
                <SuppliersFeedback />
                <BusinessNewsletter />
            </div>
        </Page>
    )
}

export default Business
